import React from 'react';
import { AlertTriangleIcon, MonitorIcon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
import { simulationFailures } from '../../data/sections';
export function SimulationProblem() {
  return <section className="bg-white px-4 py-16 md:px-8 md:py-24" data-id="element-284" data-mp="1v4wqxfwjddww">
      <div className="mx-auto max-w-3xl" data-id="element-285" data-mp="204syfp4fznh7">
        <h2 className="text-center font-display text-[26px] font-black leading-tight text-navy sm:text-4xl" data-id="element-286" data-mp="205u8prdmw5xv">
          Clear Aligners Can Look Perfect on a Screen…{' '}
          <span className="text-danger" data-id="element-287" data-mp="2a2p4w3mfpu8z">But Teeth Don’t Always Follow the Plan.</span>
        </h2>

        <div className="mt-10 space-y-4 text-[17px] leading-relaxed text-ink-muted" data-id="element-288" data-mp="2etfe5rxzeh8y">
          <p className="font-display text-xl font-extrabold text-ink" data-id="element-289" data-mp="2ivap7o5ps8zx">You’ve seen it happen.</p>
          <p data-id="element-290" data-mp="2nuvndwd28dbl">
            The digital setup looks promising. Every movement appears carefully arranged. The final simulation shows the result you’re working toward.
          </p>
          <p className="flex items-center gap-2 font-bold text-ink" data-id="element-291" data-mp="2srdomm96ltj6">
            <MonitorIcon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-292" data-mp="1dnj1y9e9to44" />
            Then treatment begins.
          </p>
        </div>

        <ul className="mt-6 space-y-3" data-id="element-293" data-mp="14l9s7lqttyrs">
          {simulationFailures.map(f => <li key={f} className="flex items-center gap-3 rounded-xl bg-danger-soft px-4 py-4 text-[16px] font-semibold text-ink" data-id="element-294" data-mp="14ndxa70gp3tn">
              <AlertTriangleIcon className="h-5 w-5 shrink-0 text-danger" aria-hidden="true" data-id="element-295" data-mp="1wcz4t3dfhsnp" />
              {f}
            </li>)}
        </ul>

        <div className="mt-8 space-y-4 text-[17px] leading-relaxed text-ink-muted" data-id="element-296" data-mp="1sbnknddbpzmw">
          <p data-id="element-297" data-mp="1nikpx1wt8k54">
            And suddenly, <strong className="text-ink" data-id="element-298" data-mp="1nhstxpzawkeb">the clinical reality no longer matches the digital simulation.</strong>
          </p>
          <p data-id="element-299" data-mp="2g06mpb5s5g6j">
            The problem isn’t always the aligner system. Sometimes, it’s the <strong className="text-ink" data-id="element-300" data-mp="2b9q65i6nxefy">predictability of the movements being planned.</strong>
          </p>
          <p data-id="element-301" data-mp="2u68ijyr3bror">That’s why understanding movement limitations before approving a setup matters.</p>
        </div>

        <p className="mt-8 border-l-4 border-brand pl-4 font-display text-lg font-extrabold leading-snug text-navy sm:text-xl" data-id="element-302" data-mp="2z5l3uf2bcqp8">
          The DENTAL PREDICTABILITY ROADMAP™ helps you approach those decisions with a more structured clinical framework.
        </p>

        <SectionCta label="I Want a Structured Framework" data-id="element-303" data-mp="2pd5lhgn3u03t" />
      </div>
    </section>;
}